import fetch from '../utils/fetch';
export function fileCreateUploadOssParams() {
  return fetch.get('/soyoung/api/file/createUploadOssParams');
}

export function fileUpload(path, file) {
  const postData = {
    filePath: path,
    file,
  };
  return fetch.upload('/soyoung/api/file/upload', postData);
}
